import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {LoaderState} from '@/store/types'

type LoaderGetter = GetterTree<LoaderState, any>
type LoaderMutation = MutationTree<LoaderState>
type LoaderAction = ActionTree<LoaderState, any>

const state: LoaderState = {
  loader: false,
  progress: 0,
}

const getters: LoaderGetter = {
  loader: (state) => state.loader,
  progress: (state) => state.progress,
}

const mutations: LoaderMutation = {
  setLoader: (state, payload) => {
    state.loader = payload
  },
  setProgress: (state, payload) => {
    state.progress = payload
  },
}

const actions: LoaderAction = {
  groupLoading: ({commit}, payload) => {
    commit('setLoader', true)
    return Promise.all(payload).then((values: any[]) => {
      commit('setLoader', false)
    })
  },
  calculateProgress: ({commit}, payload) => {
    const size = payload.file.size
    const loaded = payload.loaded
    commit('setProgress', Math.round((100 * loaded) / size))
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
